Object.assign(Globals, require('./debounce'));
